/**
 * NeutralBar — DGUI component for single-value indicator (status, metric).
 * Presentational only; schema-driven from agent/backend.
 */

import { Card, CardContent, Typography, Box } from '@mui/material';
import type { NeutralBarDGUIProps } from '@flowrithm/shared/src/features/ai-assist/types/dgui';

const cardSx = {
  borderRadius: 2,
  borderColor: 'rgba(4, 55, 123, 0.2)',
  backgroundColor: 'rgba(255, 255, 255, 0.9)',
  maxWidth: 360,
  mt: 1,
  mb: 1,
};

const statusColor: Record<string, string> = {
  positive: 'success.main',
  negative: 'error.main',
  warning: 'warning.main',
  neutral: 'text.primary',
};

export function NeutralBar({
  label,
  value,
  status = 'neutral',
  subtitle,
}: NeutralBarDGUIProps) {
  const valueColor = statusColor[status] ?? statusColor.neutral;

  return (
    <Card variant="outlined" sx={cardSx}>
      <CardContent sx={{ py: 1.5, px: 2, '&:last-child': { pb: 1.5 } }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 2,
            flexWrap: 'wrap',
          }}
        >
          <Typography variant="body2" color="text.secondary">
            {label}
          </Typography>
          <Typography variant="body2" fontWeight={600} sx={{ color: valueColor }}>
            {value}
          </Typography>
        </Box>
        {subtitle && (
          <Typography
            variant="caption"
            color="text.secondary"
            display="block"
            sx={{ mt: 0.5 }}
          >
            {subtitle}
          </Typography>
        )}
      </CardContent>
    </Card>
  );
}
